export const modelHeadersDetails = {
    airbnk: [],
    announcement: ['title', 'message', 'path', 'createdAt', 'userId'],
    card: [
        'number',
        'userFullName',
        'facilityCode',
        'cardTypeName',
        'createdAt',
        'pin',
        'expiredAt',
        'deletedAt',
        'email',
        'phoneNumber',
    ],
    card_format: ['id', 'name', 'deletedAt'],
    common_area: ['id', 'zone', 'fromTime', 'toTime', 'createdAt', 'updatedAt'],
    contract: [
        'folio',
        'contractorCompanyName',
        'contractorName',
        'contractorLastName',
        'contractorSecondLastName',
        'email',
        'phoneNumber',
        'noEmployees',
        'noVehicles',
        'startDate',
        'endDate',
    ],
    contractor: [
        'contractorCompanyName',
        'acronym',
        'address',
        'name',
        'lastName',
        'secondLastName',
        'email',
        'phoneNumber',
        'dob',
        'createdAt',
        'updatedAt',
    ],
    contractor_document: [
        'document',
        'path',
        'createdAt',
        'deletedAt',
        'updatedAt',
        'id',
        'user.id',
        'user.lastName',
        'user.secondLastName',
        'user.phoneNumber',
        'user.email',
    ],
    contractor_document_company: ['document', 'department', 'deletedAt', 'createdAt', 'instruction', 'id',],
    contractor_employee: [
        'contractor.contractorCompanyName',
        'contractor.acronym',
        'contractor.address',
        'user.fullName',
        'user.email',
        'user.phoneNumber',
        'user.dob',
        'user.documentId',
        'deletedAt',
    ],
    contractor_employee_contract: [
        'contractorEmployee.user.name',
        'contractorEmployee.user.lastName',
        'contractorEmployee.user.secondLastName',
        'contractorEmployee.user.email',
        'contractorEmployee.user.phoneNumber',
        'contractorEmployee.user.documentId',
        'contractorEmployee.user.dob',
        'contract.folio',
        'contract.description',
        'contract.startDate',
        'contract.endDate',
        'contract.deletedAt',
        'contract.noEmployees',
        'contract.noVehicles',
    ],
    contractor_vehicle: [
        'contractor.contractorCompanyName',
        'contractor.acronym',
        'contractor.address',
        'contractor.description',
        'contractor.createdAt',
        'contractor.deletedAt',
        'vehicle.brand',
        'vehicle.subBrand',
        'vehicle.model',
        'vehicle.serialNumber',
        'vehicle.color',
        'vehicle.plate',
    ],
    contractor_vehicle_contract: [],
    contractor_vehicle_document: [
        'vehicle.brand',
        'vehicle.model',
        'vehicle.subBrand',
        'vehicle.color',
        'vehicle.plate',
        'vehicle.serialNumber',
        'document',
        'path',
        'createdAt',
        'driveId',
        'updatedAt',
        'deletedAt',
    ],
    contractor_vehicle_document_company: ['document', 'path', 'createdAt', 'deletedAt'],
    contractor_work_schedule: [
        'contractor.contractorCompanyName',
        'contractor.acronym',
        'contractor.address',
        'contractor.createdAt',
        'workShiftSchedule',
        'from',
        'to',
        'deletedAt',
    ],
    department: ['id', 'name'],
    device: [
        'name',
        'ip',
        'mac',
        'zoneName',
        'serialNumber',
        'createdAt',
        'updatedAt',
        'readAfter',
    ],
    employee: ['employeeId', 'userId', 'startDate', 'endDate', 'roleName', 'zoneName'],
    employee_contract: ['id', 'user', 'path', 'driveId'],
    employee_document: [
        'user.fullName',
        'user.email',
        'user.dob',
        'user.phoneNumber',
        'document',
        'path',
        'createdAt',
        'deletedAt',
        'comment',
    ],
    employee_document_company: ['document', 'path', 'createdAt', 'deletedAt'],
    event: [
        'name',
        'hostName',
        'hostLastName',
        'hostSecondLastName',
        'hostEmail',
        'hostPhoneNumber',
        'reservationDate',
        'reservationFromTime',
        'reservationToTime',
        'startDate',
        'reservationZoneName',
        'endDate',
    ],
    firearm: [],
    firearm_type: [],
    hid: ['name', 'ipAddress', 'channelId', 'scpId', 'noSio', 'description', 'id'],
    hid_card_format: [
        'cardFormat.id',
        'cardFormat.name',
        'cardFormat.command',
        'facilityCode',
        'hid.ipAddress',
        'hid.channelId',
        'deletedAt',
    ],
    hid_input: [
        'name',
        'number',
        'noSio',
        'sioType',
        'hidName',
        'noSio',
        'ipAddress',
        'scpId',
        'channelId',
        'deletedAt',
    ],
    hid_output: [],
    hid_reader: ['hidName', 'ipAddress', 'noSio', 'sioType', 'keepOpen', 'readerNo', 'deletedAt'],
    hid_sio: ['name', 'hidName', 'number', 'noSio', 'ipAddress', 'deletedAt'],
    hid_work_shift: ['id', 'hid', 'workShift'],
    holiday: [],
    live_content: [],
    onboarding: [
        'user.name',
        'user.lastName',
        'user.secondLastName',
        'user.documentId',
        'user.phoneNumber',
        'user.email',
        'user.dob',
        'user.createdAt',
        'deletedAt',
    ],
    onboarding_image: [],
    onboarding_process: ['id', 'process', 'createdAt', 'deletedAt'],
    purchase: [
        'folio',
        'supplierName',
        'supplierLastName',
        'supplierSecondLastName',
        'supplierCompanyAcronym',
        'supplierCompanyName',
        'supplierEmployeeName',
        'supplierEmployeeEmail',
        'supplierEmployeePhoneNumber',
        'supplierVehicleBrand',
        'supplierVehicleSubBrand',
        'supplierVehiclePlate',
        'item',
        'deliveryDate',
        'userReceivedName',
        'userReceivedLastName',
        'deliveryDate',
    ],
    relative: [],
    report: [],
    reservation: [
        'zone.name',
        'zone.createdAt',
        'zone.latitud',
        'zone.longitud',
        'fromTime',
        'toTime',
        'reservationDate',
        'createdAt',
        'updatedAt',
        'deletedAt',
    ],
    resource: ['id', 'name', 'path'],
    role: ['id', 'name', 'createdAt', 'updatedAt', 'deletedAt'],
    smart_lock: [],
    supplier: [
        'supplierCompanyName',
        'acronym',
        'address',
        'name',
        'lastName',
        'secondLastName',
        'email',
        'phoneNumber',
        'dob',
        'documentId',
    ],
    supplier_document: ['id', 'status', 'user', 'validatedBy'],
    supplier_document_company: [
        'document',
        'path',
        'createdAt',
        'deletedAt',
        'department.name',
    ],
    supplier_employee: [
        'supplier.supplierCompanyName',
        'user.name',
        'user.lastName',
        'user.secondLastName',
        'user.dob',
        'user.documentId',
        'user.phoneNumber',
        'user.email',
        'deletedAt',
    ],
    supplier_vehicle: [
        'supplier.supplierCompanyName',
        'supplier.acronym',
        'supplier.address',
        'vehicle.brand',
        'vehicle.model',
        'vehicle.plate',
        'vehicle.color',
        'vehicle.serialNumber',
        'deletedAt',
    ],
    supplier_vehicle_document: [
        'document',
        'path',
        'deletedAt',
        'createdAt',
        'vehicle.brand',
        'vehicle.plate',
        'vehicle.subBrand',
        'vehicle.color',
        'comment',
    ],
    supplier_vehicle_document_company: ['document', 'path', 'createdAt', 'deletedAt'],
    tag: ['id', 'vehicle', 'tag'],
    template: ['id', 'name', 'whoCreatedId'],
    user_announcement: [
        'user.name',
        'user.lastName',
        'user.secondLastName',
        'user.documentId',
        'user.phoneNumber',
        'user.email',
        'announcement.title',
        'announcement.message',
        'announcement.path',
        'announcement.createdAt',
        'deletedAt',
    ],
    user_image: [
        'user.name',
        'user.lastName',
        'user.secondLastName',
        'user.documentId',
        'user.phoneNumber',
        'user.email',
        'path',
        'description',
        'createdAt',
        'deletedAt',
    ],
    user_invitation: [
        'hostName',
        'hostLastName',
        'hostSecondLastName',
        'visitorName',
        'visitorLastName',
        'visitorSecondLastName',
        'visitorEmail',
        'visitorPhoneNumber',
        'zoneName',
        'startDate',
        'endDate',
    ],
    user_process: ['id', 'user', 'onboardingProcess'],
    user_vehicle_company: ['id', 'vehicleCompany', 'employee', 'vehiclePermissionType', 'from', 'to'],
    user_work_schedule: [
        'user.fullName',
        'from',
        'to',
        'deletedAt',
        'user.name',
        'user.lastName',
        'user.secondLastName',
        'user.phoneNumber',
        'user.dob',
        'user.documentId',
        'deletedAt',
    ],
    user_zone: ['id', 'user', 'zone'],
    vehicle_company: [
        'vehicle.brand',
        'vehicle.subBrand',
        'vehicle.model',
        'vehicle.color',
        'vehicle.plate',
        'vehicle.serialNumber',
        'vehicle.createdAt',
    ],
    vehicle_image: [
        'path',
        'deletedAt',
    ],
    vehicle_invitation: [],
    work_shift: ['id', 'name'],
    work_shift_schedule: ['workShift.name', 'from', 'to', 'zone.latitud', 'zone.longitud', 'deletedAt'],
    zone: ['id', 'zone.name', 'createdAt', 'deletedAt'],
    zone_plane: ['id', 'zone', 'name', 'driveId', 'path'],
};
